import type { FC, PropsWithChildren } from 'react';

import { Button, ButtonLink } from '@coop/components';

import styles from './SearchOverlayFooterButton.module.scss';

type SearchOverlayFooterButtonProps = PropsWithChildren<
    | {
          as: 'link';
          href: string;
          onClick?: () => void;
      }
    | {
          as: 'button';
          onClick?: () => void;
      }
>;

const SearchOverlayFooterButton: FC<SearchOverlayFooterButtonProps> = (props) => {
    const { children } = props;

    return (
        <div className={styles.Footer}>
            {props.as === 'link' ? (
                <ButtonLink
                    theme="primary"
                    size="large"
                    fullWidth
                    href={props.href}
                    onClick={(event) => {
                        event.preventDefault();
                        props.onClick?.();
                    }}
                >
                    {children}
                </ButtonLink>
            ) : (
                <Button
                    theme="primary"
                    size="large"
                    fullWidth
                    type="button"
                    onClick={props.onClick}
                >
                    {children}
                </Button>
            )}
        </div>
    );
};

export default SearchOverlayFooterButton;
